import { useMemo } from 'react';
import { IMPRESSION_TYPE } from '../../../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import {
    ENABLE_OCC_BITE_RAMP_QUESTION,
    ENABLE_POTIC_RETAINER_TYPE,
    getEnableClearDesignQuestionList,
} from '../../../../pages/DiffRetainer/utils';
import { CaseImpressionFileType } from '../../../../pages/DiffRetainer/modal/type';

/**
 * 根据当前表单值判断各个处方问题是否需要显示。
 */
const useFormQuestionEnable = ({ formValues, impressionType = IMPRESSION_TYPE.UPPER, subType = '' }) => {
    const getAccessKey = (field = '') => {
        if (impressionType === IMPRESSION_TYPE.UPPER_AND_LOWER && ['Upper', 'Lower'].includes(subType)) {
            return `${subType}${field.charAt(0).toUpperCase() + field.slice(1)}`;
        } else return field;
    };
    const enableOccBiteRampQuestion = useMemo(() => {
        const accessKey = getAccessKey('archAndQuantity');
        const selectedRetainer = formValues[accessKey];
        return ENABLE_OCC_BITE_RAMP_QUESTION.includes(selectedRetainer);
    }, [formValues]);

    const enableClearRetainerDesignQuestion = useMemo(() => {
        const selectedRetainer = formValues[getAccessKey('archAndQuantity')];
        const hasWire = formValues[getAccessKey('fixedWire')];

        // if(selectedRetainer === 'ecodontRetainersWithWire') return true
        if (hasWire === 'false') return false;

        return getEnableClearDesignQuestionList(hasWire).includes(selectedRetainer);
    }, [formValues]);

    // based on requirement, bascially no retainer option would enable for design question for second set
    // const enableClearRetainerDesignQuestionForSecondSetRetainer = useMemo(() => {
    //     const selectedRetainer = formValues[getAccessKey('archAndQuantity')]
    //     const hasWire = formValues[getAccessKey('fixedWire')]
    //     let clearRetainerDesign = null

    //     switch (impressionType) {
    //         case IMPRESSION_TYPE.UPPER:
    //             clearRetainerDesign = formValues[getAccessKey('clearRetainerDesignUpperOption')]
    //             break;
    //         case IMPRESSION_TYPE.LOWER:
    //             clearRetainerDesign = formValues[getAccessKey('clearRetainerDesignLowerOption')]
    //             break;
    //         case IMPRESSION_TYPE.UPPER_AND_LOWER:
    //             if(subType) {
    //                 if(subType === 'Upper') {
    //                     clearRetainerDesign = formValues[getAccessKey('clearRetainerDesignUpperOption')]
    //                 }
    //                 if(subType === 'Lower') {
    //                     clearRetainerDesign = formValues[getAccessKey('clearRetainerDesignLowerOption')]
    //                 }
    //             }
    //             break;
    //         default:
    //             break;
    //     }

    //     if(hasWire === 'false') return false
    //     if(selectedRetainer === "ecodontRetainers" || selectedRetainer === 'clearRetainer') return false
    //     return ENABLE_CLEAR_DESIGN_QUESTION_FOR_SECOND_SET.includes(selectedRetainer)
    // },[formValues])

    const enablePontic = useMemo(() => {
        const selectedRetainer = formValues[getAccessKey('archAndQuantity')];
        return ENABLE_POTIC_RETAINER_TYPE.includes(selectedRetainer);
    }, [formValues]);

    const enableUploadImpression = useMemo(() => {
        return formValues['impressionOption'] === CaseImpressionFileType.FILE;
    }, [formValues]);

    return {
        enableOccBiteRampQuestion,
        enableClearRetainerDesignQuestion,
        // enableClearRetainerDesignQuestionForSecondSetRetainer,
        enablePontic,
        enableUploadImpression,
    };
};

export default useFormQuestionEnable;
